<template>
  <div class="containerfluid">
    <apexchart :key="chartdata" height="200" :options="ApexChartOptions" :series="ApexChartOptions.series"></apexchart>
  </div>
</template>
<script>
export default {
  data() {
    return {
      chartdata: [],
      ApexChartOptions: {
        chart: {
          type: 'donut',
        },
        dataLabels: {
          enabled: false,
        },
        colors: ['#435EBE', '#CCE5FF', '#694467', '#2A3F54', '#21AE89', '#fd397a', '#5CB0FF', '#FDA700', '#11e345', '#78eb8d', '#f56905'],
        series: [],
        labels: [],
        stroke: {
          show: false,
        },
      },
    }
  },
  methods: {
    GetAcconts() {
      var DataAxiosRow = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      }
      var list = []
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      DataAxiosRow.ArryfildValue = formData
      this.$PostFormData(DataAxiosRow).then((data) => {
        data.forEach((element) => {
          element.mande = element.mande + element.sumMabTaeedNaShode
          this.ApexChartOptions.labels.push(element.desNoe)
          this.ApexChartOptions.series.push(element.mande)
        })
      })
    },
  },
  created() {
    this.GetAcconts()
  },
}
</script>
